var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83317 3.125C5.5569 3.125 5.29195 3.23475 5.0966 3.4301C4.90125 3.62545 4.7915 3.8904 4.7915 4.16667V15.8333C4.7915 16.1096 4.90125 16.3746 5.0966 16.5699C5.29195 16.7653 5.5569 16.875 5.83317 16.875H9.58317C9.92835 16.875 10.2082 17.1548 10.2082 17.5C10.2082 17.8452 9.92835 18.125 9.58317 18.125H5.83317C5.22538 18.125 4.64249 17.8836 4.21272 17.4538C3.78295 17.024 3.5415 16.4411 3.5415 15.8333V4.16667C3.5415 3.55888 3.78295 2.97598 4.21272 2.54621C4.64249 2.11644 5.22538 1.875 5.83317 1.875H11.6665C11.8323 1.875 11.9912 1.94085 12.1084 2.05806L16.2751 6.22473C16.3923 6.34194 16.4582 6.50091 16.4582 6.66667V10.8333C16.4582 11.1785 16.1783 11.4583 15.8332 11.4583C15.488 11.4583 15.2082 11.1785 15.2082 10.8333V7.29167H12.4998C12.1131 7.29167 11.7421 7.13802 11.4686 6.86453C11.1951 6.59104 11.0415 6.22011 11.0415 5.83333V3.125H5.83317ZM12.2915 4.00888L14.3243 6.04167H12.4998C12.4446 6.04167 12.3916 6.01972 12.3525 5.98065C12.3135 5.94158 12.2915 5.88859 12.2915 5.83333V4.00888ZM14.5579 12.8914C14.802 12.6473 15.1977 12.6473 15.4418 12.8914L17.9418 15.3914C18.1859 15.6355 18.1859 16.0312 17.9418 16.2753L15.4418 18.7753C15.1977 19.0194 14.802 19.0194 14.5579 18.7753C14.3138 18.5312 14.3138 18.1355 14.5579 17.8914L15.991 16.4583H11.6665C11.3213 16.4583 11.0415 16.1785 11.0415 15.8333C11.0415 15.4882 11.3213 15.2083 11.6665 15.2083H15.991L14.5579 13.7753C14.3138 13.5312 14.3138 13.1355 14.5579 12.8914Z",
    fill: "#252527"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.6e0ca22e40669662a4276e1f4db7f039.svg";
export { ForwardRef as ReactComponent };